export default class CustomFields
{
  constructor(names, options, required, hasPrice) 
  {
    this.names = names; // {} instead of array to support stringify
    this.options = options;
    this.required = required;
    this.hasPrice = hasPrice;
  }    

  isValid()
  {
    var result = true;
    
    for (const [key, value] of Object.entries(this.names)) {
      if(!value)
      {
        result = false;
        break;
      }
    }

    if(this.required == undefined || this.required == null)
    {
      this.required = false;
    }

    
    if(result) result = this.options && this.options.length;

    return result;
  }
}